import React from 'react';
export function PublicFooter() {
  return <footer className="bg-white border-t border-borderColor py-12" data-id="element-242">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-243">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-244">
          <div className="flex items-center" data-id="element-245">
            <img src="https://cdn.magicpatterns.com/uploads/u4AKTM42BTBGHrLv1PiYxT/Logo_3.png" alt="LawVo" className="h-8 object-contain" data-id="element-246" />
          </div>
          <div className="flex items-center gap-6" data-id="element-247">
            <span className="text-sm text-secondary" data-id="element-248">Privacy Policy</span>
            <span className="text-sm text-secondary" data-id="element-249">Terms of Service</span>
            <span className="text-sm text-secondary" data-id="element-250">Contact</span>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-borderColor text-center" data-id="element-251">
          <p className="text-sm text-secondary" data-id="element-252">
            &copy; {new Date().getFullYear()} LawVo. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}